module.exports = __webpack_public_path__ + "img/avatar0.a3d03a0f.png";